import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { Permission } from '../common/Utils/permissions';
import { usePermissions } from '../hooks/usePermissions';

type LocationState = {
  from?: { pathname: string };
};

type ProtectedRouteProps = {
  allowedRoles?: string[];
  // Gate the route behind an edit-capable permission area (e.g. 'remediationPlan', 'groupPolicies').
  // Users whose access level for this area is read-only ('view') or absent are redirected away.
  requireEditAccess?: keyof Permission;
};

const ProtectedRoute = ({ allowedRoles, requireEditAccess }: ProtectedRouteProps) => {
  const { role, canEdit } = usePermissions();

  const location = useLocation();
  const state = location.state as LocationState | null;
  const fallback = '/';

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={state?.from?.pathname || fallback} replace state={{ from: location }} />;
  }

  if (requireEditAccess && !canEdit(requireEditAccess)) {
    return <Navigate to={state?.from?.pathname || fallback} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
